import { useEffect, useState } from "react";
import DashboardHeader from "../DashboardHeader";
import DashboardFilters from "../DashboardFilters";
import DashboardTable from "../DashboardTable";
import ApprovedPaymentsList from "./ApprovedPaymentsList";
import { LuArrowLeft, LuArrowRight } from "react-icons/lu";

const approved_payments = [
    {
        receipt_id: '24221',
        full_name: 'Armir Qurdina',
        email: 'armiqurdina@gmail.com',
        payment_type: 'Basic',
        plan_started: '01.08.2024',
        plan_ended: '01.09.2024'
    },
    {
        receipt_id: '76355',
        full_name: 'Armir Qurdina',
        email: 'armiqurdina@gmail.com',
        payment_type: 'Premium',
        plan_started: '01.08.2024',
        plan_ended: '01.09.2024'
    },
    {
        receipt_id: '2534',
        full_name: 'Armir Qurdina',
        email: 'armiqurdina@gmail.com',
        payment_type: 'Unlimited',
        plan_started: '01.08.2024',
        plan_ended: '01.09.2024'
    },
    {
        receipt_id: '23456',
        full_name: 'Armir Qurdina',
        email: 'armiqurdina@gmail.com',
        payment_type: 'Premium',
        plan_started: '01.08.2024',
        plan_ended: '01.09.2024'
    },
    {
        receipt_id: '43879',
        full_name: 'Armir Qurdina',
        email: 'armiqurdina@gmail.com',
        payment_type: 'Basic',
        plan_started: '01.08.2024',
        plan_ended: '01.09.2024'
    },
    {
        receipt_id: '81213',
        full_name: 'Armir Qurdina',
        email: 'armiqurdina@gmail.com',
        payment_type: 'Unlimited',
        plan_started: '01.08.2024',
        plan_ended: '01.09.2024'
    },
    {
        receipt_id: '70968',
        full_name: 'Armir Qurdina',
        email: 'armiqurdina@gmail.com',
        payment_type: 'Basic',
        plan_started: '01.08.2024',
        plan_ended: '01.09.2024'
    },
]

export default function ApprovedPayments() {

    const [filteredApprovedPayments, setFilteredApprovedPayments] = useState(approved_payments || null)
    const [filterSelected, setFilterSelected] = useState("")
    const [showFilters, setShowFilters] = useState(true)

    const handleFilterSelect = (e) => {
        if (filterSelected === e.target.innerText) {
            setFilterSelected("")
            return;
        }
        setFilterSelected(e.target.innerText)
    }

    const handleShowFilters = () => {
        setShowFilters(!showFilters)
    }

    useEffect(() => {
        if (!filterSelected.length) {
            setFilteredApprovedPayments(approved_payments)
            return;
        }
        setFilteredApprovedPayments(approved_payments.filter(payment => payment.payment_type === filterSelected))
    }, [filterSelected])

    const details = {
        title: 'Approved Payments',
        count: approved_payments.length,
    }

    const buttons = [
        {
            label: 'Back',
            color: 'bg-white',
            border: 'border border-[#D0D5DD]',
            linkTo: '/payments',
            onClick: null,
            shadow: true
        }
    ]

    const tableData = {
        headLabels: ['Receipt ID', 'Name & Surname', 'Email', 'Payment Type', 'Plan Started', 'Plan Ended'],
        list: <ApprovedPaymentsList payments={filteredApprovedPayments} />,
        data: filteredApprovedPayments
    }

    const filters = {
        categories: ['Basic', 'Premium', 'Unlimited'],
        selectedFilter: filterSelected,
        handleFilterSelect: handleFilterSelect,
        showFilters: showFilters,
        handleShowFilters: handleShowFilters
    }

    return (
        <>
            <DashboardHeader details={details} buttons={buttons} />
            <hr />
            <DashboardFilters filters={filters} />
            <DashboardTable tableData={tableData} />
            <div className="p-4 flex justify-between items-center w-full text-sm font-semibold">
                <div className="px-3 p-2 border border-gray-200 rounded-xl flex gap-2 items-center cursor-pointer">
                    <LuArrowLeft style={{ fontSize: '18px' }} />
                    <div className="leading-3">Previous</div>
                </div>
                <div>Pages</div>
                <div className="px-3 p-2 border border-gray-200 rounded-xl flex gap-2 items-center cursor-pointer">
                    <div className="leading-3">Next</div>
                    <LuArrowRight style={{ fontSize: '18px' }} />
                </div>
            </div>
        </>
    )
}